<script lang="ts">
    import { onMount } from 'svelte'
    import dayjs from 'dayjs'
    import utc from 'dayjs/plugin/utc'
    dayjs.extend(utc)
    import Flatpickr from 'svelte-flatpickr'
    import 'flatpickr/dist/flatpickr.css' // import { Setting } from '../../modules/integrationsApi/settings/setting'
    import 'flatpickr/dist/themes/dark.css'
    import { Portuguese } from 'flatpickr/dist/l10n/pt.js'
    import DashboardProductivityBar from './dashboard-productivity-bar.svelte'
    import { EventSourcesRepository } from '../../modules/eventsApi/event-sources/event-sources.repository'
    import { EventSourcesService } from '../../modules/eventsApi/event-sources/event-sources.service'
    import { CompaniesRepository } from '../../modules/usersApi/companies/companies.repository'
    import { CompaniesService } from '../../modules/usersApi/companies/companies.service'
    import type { User } from '../../modules/usersApi/users/user'
    import Fa from 'svelte-fa'
    import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
    import { faEnvelope, faPhone, faSms } from '@fortawesome/free-solid-svg-icons'
    import type { EventSource } from '../../modules/eventsApi/event-sources/event-source.entity'
    import type { Channel } from '../../modules/brokerApi/channels/channel'

    const esR = new EventSourcesRepository()
    const esS = new EventSourcesService(esR)

    const compR = new CompaniesRepository()
    const compS = new CompaniesService(compR)

    let start: number
    let end: number
    let show = true
    let eSources: EventSource[] = []
    let usersEvents: { user: User; events: any[] }[] = []
    let users: any[] = []

    async function loadBars() {
        show = true
        start = 420
        end = 1080
        selectedDate.setHours(0)
        selectedDate.setMinutes(0)
        selectedDate.setSeconds(0)
        let utcDate = new Date(dayjs(selectedDate).format('YYYY-MM-DD'))
        let from = dayjs(utcDate).add(utcDate.getTimezoneOffset(), 'm').toISOString()
        let to = dayjs(new Date(utcDate.setDate(utcDate.getDate() + 1)))
            .add(utcDate.getTimezoneOffset(), 'm')
            .toISOString()
        let params = {
            from,
            to,
            externaldate: true,
            sources: ['whatsapp', 'voip', 'telefone', 'sms', 'email'],
        }
        eSources = await esS.getAll(params)
        const channels: Channel[] = await window.api.brokers.channels.getAll()
        for (const es of eSources) {
            es.channel = channels.find((el) => el.channelId === es.channelId)
        }
        users = await compS.getCompanyUsers()
        users.unshift({ userName: 'Zandu', userId: 'znd' })

        await updateByUser()
        show = false
    }

    async function updateByUser() {
        usersEvents = []
        for (const user of users) {
            let userEvents: { user: User; events: any[] } = { user: null, events: [] }
            for (const es of eSources) {
                es.externalDate = new Date(es.externalDate)
                if (user.userId === es.channel?.userId) {
                    if (
                        ((es.source === 'voip' || es.source === 'celular' || es.source === 'telefone') &&
                            (es.event[0].event === 'comunicacao_enviada' ||
                                es.event[0].event === 'comunicacao_recebida')) ||
                        es.event[0].event === 'comunicacao_enviada'
                    ) {
                        setStart(es.externalDate)
                        userEvents.events.push(es)
                    }
                }
                // } else if (user.userId === 'znd') {
                //     if (es.event[0].event.includes('automacao_')) {
                //         userEvents.events.push(es)
                //     }
                // }
            }
            if (userEvents.events.length > 0) {
                userEvents.user = user
                usersEvents.push(userEvents)
            }
        }
        usersEvents = usersEvents
    }

    function setStart(date: Date) {
        while (start > date.getHours() * 60 + date.getMinutes()) {
            start -= 60
        }
        while (end < date.getHours() * 60 + date.getMinutes()) {
            end += 60
        }
        if (start < 0) start = 0
        if (end > 1440) end = 1440
    }

    // ===================================
    let selectedDate = new Date()
    let formatedDate = dayjs(new Date()).format('YYYY-MM-DD')
    const options = {
        inline: true,
        locale: Portuguese,
    }

    function handleChange(event) {
        const [selectedDates, dateStr] = event.detail
        console.log('changed', dateStr)
        setTimeout(loadBars, 100)
    }

    function handleChangeMobile(event) {
        selectedDate = new Date(formatedDate)
        selectedDate.setMinutes(new Date(formatedDate).getMinutes() + new Date(formatedDate).getTimezoneOffset())
        console.log('chenged mob', formatedDate)
        loadBars()
    }

    let onlySuccess = false
    let byTime = false

    onMount(async () => {
        //await loadSettings()
        selectedDate = new Date()
        await loadBars()
    })
</script>

<div class="root">
    <div class="controls config-box">
        <div class="calendar">
            <div class="btn-group" role="group">
                <div class="h-mobile">
                    <Flatpickr
                        {options}
                        bind:value={selectedDate}
                        bind:formattedValue={formatedDate}
                        on:change={handleChange}
                    />
                </div>
                <input
                    class="form-control h-full"
                    type="date"
                    bind:value={formatedDate}
                    on:change={handleChangeMobile}
                />
            </div>
        </div>
        <div class="sets">
            <div
                class="form-check form-switch mt-2"
                title="Exibe apenas conversas com mais de 1 minuto ou mais de 3 mensagens trocadas."
            >
                <input
                    class="form-check-input"
                    bind:checked={onlySuccess}
                    on:change={updateByUser}
                    type="checkbox"
                    role="switch"
                    id="npsOn"
                />
                <label class="form-check-label" for="npsOn">Exibir apenas com sucesso</label>
            </div>

            <div class="form-check form-switch mt-2" title="Exibe pelo tempo ou volume de mensagens.">
                <input
                    class="form-check-input"
                    bind:checked={byTime}
                    on:change={updateByUser}
                    type="checkbox"
                    role="switch"
                    id="npsOn"
                />
                <label class="form-check-label" for="npsOn">Exibir por tempo/mensagens</label>
            </div>
        </div>
        <div class="spacer h-mobile" />
        <div class="labels h-mobile">
            <div class="row">
                <div class="col text-muted">
                    <div class="item">
                        <div class="item-box">
                            <Fa icon={faWhatsapp} />
                        </div>
                        <div class="item-label">Contato por WhatsApp</div>
                    </div>
                    <div class="item">
                        <div class="item-box">
                            <Fa icon={faPhone} />
                        </div>
                        <div class="item-label">Contato por telefone</div>
                    </div>
                    <div class="item">
                        <div class="item-box">
                            <Fa icon={faEnvelope} />
                        </div>
                        <div class="item-label">Contato por e-mail</div>
                    </div>
                    <div class="item">
                        <div class="">
                            O números presentes neste relatório representam a quantidade de pessoas contactadas a cada
                            30 minutos. Ou caso a opção "Exibir tempo/mensagens" esteja ativa, representa o tempo falado
                            ou mensagens enviadas. Caso a mesma pessoa seja contactada mais de uma vez durante o dia,
                            então ela aparecerá em todos os os horários nos quais foi contactada. Ligações não
                            completadas podem não aparecer no relatório.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="board">
        {#if !show}
            {#each usersEvents as userEvents, index}
                <DashboardProductivityBar {onlySuccess} {byTime} {userEvents} {start} {end} />
            {:else}
                <div class="not text-muted">
                    Não há comunicação feita por usuários no período.
                    <ul>
                        <li>Selecione outra data</li>
                        <li>
                            Associe um provedor de comunicação a um usuário específico no menu Ferramentas &gt;
                            Provedores...
                        </li>
                    </ul>
                </div>
            {/each}
        {/if}
    </div>
</div>

<style>
    .not {
    }
    .root {
        overflow: hidden;
        display: flex;
        padding-top: 16px;
        align-items: flex-start;
    }

    .controls {
        display: flex;
        flex-direction: column;
        flex: 0 0 220px;
        margin-right: 8px;
    }

    .board {
        flex-grow: 1;
        display: flex;
        height: 100%;
        user-select: none;
        padding: 8px;
        padding-bottom: 200px;
        flex-wrap: wrap;
        gap: 16px;
    }

    .labels {
        margin-top: 4px;
        font-size: 13px;
    }
    .labels .item {
        display: flex;
        margin-top: 4px;
    }
    .labels .item-box {
        margin-right: 4px;
    }
    @media (max-width: 900px) {
        .root {
            flex-direction: column;
            padding-top: 0px;
        }
        .controls {
            flex: 0 0 auto;
            margin-bottom: 8px;
            flex-direction: unset;
        }
        .calendar {
            flex-grow: 1;
            display: flex;
        }
        .calendar .btn-group {
            flex-grow: 1;
        }

        .config-box {
            padding: 0px;
            background: unset;
        }
        .board {
            padding: 0px 1px;
            flex-direction: column;
            padding-bottom: 104px;
        }
    }
    :global(.flatpickr-input) {
        display: none;
    }

    :global(.flatpickr-day.today) {
        border-color: #999 !important;
    }

    :global(.flatpickr-day.selected) {
        background: #9c4dcc !important;
        border-color: #9c4dcc !important;
    }

    :global(.numInputWrapper span:hover) {
        background: #222 !important;
    }
    :global(.flatpickr-calendar) {
        font-size: 13px;
        width: 240px !important;
        min-width: 240px !important;
        max-width: 240px !important;
    }
    :global(.flatpickr-days) {
        width: 240px !important;
        min-width: 240px !important;
        max-width: 240px !important;
    }

    :global(.flatpickr-day) {
        height: 32px !important;
        padding-top: -6px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
    }
    :global(.dayContainer) {
        width: 240px !important;
        min-width: 240px !important;
        max-width: 240px !important;
    }
    .sets {
        font-size: 13px;
    }
</style>
